import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>When not effectively managed, groups can start judging
                                                contributions too early in the process,
                                                which may inhibit it. One way to avoid this is ‘reverse
                                                brainstorming’, by asking everyone for
                                                reasons why something might not work: ‘What could go wrong
                                                if we outsourced to India?’
                                                This allows contributors to air their concerns about a
                                                proposal before discussing how each might
                                                be resolved.</p>
                                            <p>It’s always important to use a skilled facilitator to ensure
                                                brainstorming sessions work effectively,
                                                especially when reverse brainstorming, to prevent the
                                                negativity dominating proceedings, and the
                                                champion of a cause being left feeling under attack!</p>
                                            <div className="border_subtitle">Six hat thinking system<a
                                                className="superscripttext superBold"
                                                href="further_info.php?course=300"><sup>8</sup></a></div>
                                            <p>This is a way of encouraging lateral thinking using six
                                                differently coloured, symbolic hats (the
                                                ‘hats’ could be badges or any other visible marker which
                                                individuals could wear or pick up). Each
                                                indicates a different way of thinking about something. They
                                                should never be used to symbolise
                                                individuals, although people could be asked to hold up or
                                                wear a particular hat, to indicate the
                                                kind of thinking they’re adopting, when speaking.</p>
                                            <p>In a group, the hats could be used in a specific sequence or
                                                as part of a discussion, where they
                                                can be used as required, for example ‘I think we should have
                                                5 minutes of "green hat thinking"
                                                before taking this discussion further.’</p>
                                            <div className="desktop ilead-model">
                                                <table
                                                    className="ilead_v_sport tablesrink uiheading ilead_v_sport_new_task"
                                                    border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve green_curve1" colSpan="2"
                                                            align="left" valign="center" width="100%">Six
                                                            Thinking Hats
                                                        </th>
                                                    </tr>

                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>1. White hat</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="80%"><p>Data gathering mode: facts,
                                                            figures, asking questions, defining
                                                            informational
                                                            needs and gaps.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>2. Red hat</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="80%"><p>Intuition and emotions may be
                                                            expressed without being supported by logic.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>3. Black hat</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="80%"><p>Logical negative, judgement and
                                                            caution: a very important hat that might need
                                                            to be used more than others. It’s critical that
                                                            it remains logical.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>4. Yellow hat</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="80%"><p>Logical positive: looks at the
                                                            value and advantages of an issue or why it has
                                                            worked previously or elsewhere.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="20%"><p>5. Green hat</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="80%"><p>Provocations, alternatives and
                                                            creativity.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="20%"><p>6. Blue hat</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="80%"><p>Overview and process control:
                                                            concerned not with the issue under discussion,
                                                            but methods and logic.</p>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mobile ilead-model">
                                                <table
                                                    className="ilead_v_sport tablesrink uiheading ilead_v_sport_new_task"
                                                    border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve green_curve1" colSpan="2"
                                                            align="left" valign="center" width="100%">Six
                                                            Thinking Hats
                                                        </th>
                                                    </tr>

                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%"><p>1. White hat</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="60%"><p>Data gathering mode: facts,
                                                            figures, asking questions, defining
                                                            informational
                                                            needs and gaps.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%"><p>2. Red hat</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="60%"><p>Intuition and emotions may be
                                                            expressed without being supported by logic.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%"><p>3. Black hat</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="60%"><p>Logical negative, judgement and
                                                            caution: a very important hat that might need
                                                            to be used more than others. It’s critical that
                                                            it remains logical.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%"><p>4. Yellow hat</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="60%"><p>Logical positive: looks at the
                                                            value and advantages of an issue or why it has
                                                            worked previously or elsewhere.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%"><p>5. Green hat</p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="60%"><p>Provocations, alternatives and
                                                            creativity.</p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%"><p>6. Blue hat</p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="60%"><p>Overview and process control:
                                                            concerned not with the issue under discussion,
                                                            but methods and logic.</p>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>


                                            <p>In wearing a specific hat, an individual can express
                                                thoughts, concerns or feelings as part of the
                                                process rather than as personal opinions which he or she
                                                feels are vulnerable to judgement by others.
                                                It also enables a group to overcome some of the biases we’ve
                                                discussed, and consider an issue from
                                                different or unaccustomed perspectives. Here are examples of
                                                hats with different attitudes!</p>

                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/hat.png')}/>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}